// extracted by mini-css-extract-plugin
export default {"image":"R1-z","loaded":"S1-z"};